import { storyblokEditable } from "gatsby-source-storyblok"
import React from "react"

import QuoteTextCard from "../../../../V2/Cards/Content/QuoteTextCard"

import { storyblokLinkToYocoLink } from "@utils/storyblok"

const StoryblokQuoteTextCard = ({
  blok,
}: Storyblok.BlokProps<Storyblok.QuoteTextCard>) => {
  return (
    <QuoteTextCard
      backgroundColor={blok.backgroundColor}
      title={blok.title}
      quote={blok.quote}
      image={blok.image.filename}
      name={blok.name}
      occupation={blok.occupation}
      ctaLink={storyblokLinkToYocoLink(blok.ctaLink)}
      ctaText={blok.ctaText}
      style={blok.style}
      // @ts-ignore to have more strict typing compared to Storybloks generic object typing
      {...storyblokEditable(blok)}
    />
  )
}

export default StoryblokQuoteTextCard
